module.exports = __webpack_public_path__ + "static/logo-2a8186a0e6ef2611b52c0c4e9f12e9b2.png";